import { callAPI } from "store";
import {
  CLEAR_ERROR_DELETING_YARD_MAP,
  CREATE_YARD_MAP,
  CREATE_YARD_MAP_FAILURE,
  CREATE_YARD_MAP_SUCCESS,
  DELETE_YARD_MAP,
  DELETE_YARD_MAP_FAILURE,
  DELETE_YARD_MAP_SUCCESS,
  FETCH_YARD_MAP,
  FETCH_YARD_MAP_FAILURE,
  FETCH_YARD_MAP_SUCCESS,
  RESET_YARD_MAP_STATE,
} from "./yardMapActionTypes";
import { APIs } from "app-constants";

export const fetchYardMap = (yardId) => {
  return async (dispatch, getState) => {
    dispatch(fetchYardMapRequest(yardId));

    try {
      const responseJson = await callAPI(getState().accountInfo, APIs.GET_YARD_MAP, { yardId });

      dispatch(fetchYardMapSuccess(responseJson));
    } catch (exception) {
      dispatch(fetchYardMapFailure(exception.message));
    }
  };
};

const fetchYardMapRequest = (yardId) => {
  return {
    type: FETCH_YARD_MAP,
    payload: yardId,
  };
};

const fetchYardMapSuccess = (yardMap) => {
  return {
    type: FETCH_YARD_MAP_SUCCESS,
    payload: yardMap,
  };
};

const fetchYardMapFailure = (error) => {
  return {
    type: FETCH_YARD_MAP_FAILURE,
    payload: error,
  };
};

export const createYardMap = (yardMapData) => {
  return async (dispatch, getState) => {
    dispatch(createYardMapRequest());
    try {
      const requestBody = {
        yardMap: yardMapData,
      };

      const responseJson = await callAPI(getState().accountInfo, APIs.CREATE_YARD_MAP, requestBody);
      dispatch(createYardMapSuccess(responseJson.yardMap));
    } catch (exception) {
      dispatch(createYardMapFailure(exception.message));
    }
  };
};

const createYardMapRequest = () => {
  return {
    type: CREATE_YARD_MAP,
  };
};

const createYardMapSuccess = (yardMap) => {
  return {
    type: CREATE_YARD_MAP_SUCCESS,
    payload: yardMap,
  };
};

const createYardMapFailure = (error) => {
  return {
    type: CREATE_YARD_MAP_FAILURE,
    payload: error,
  };
};

export const deleteYardMap = (yardId, version) => {
  return async (dispatch, getState) => {
    dispatch(deleteYardMapRequest());
    try {
      await callAPI(getState().accountInfo, APIs.DELETE_YARD_MAP, { yardId, version });
      dispatch(deleteYardMapSuccess());
    } catch (exception) {
      dispatch(deleteYardMapFailure(exception.message));
    }
  };
};

const deleteYardMapRequest = () => {
  return {
    type: DELETE_YARD_MAP,
  };
};

const deleteYardMapSuccess = () => {
  return {
    type: DELETE_YARD_MAP_SUCCESS,
  };
};

const deleteYardMapFailure = (error) => {
  return {
    type: DELETE_YARD_MAP_FAILURE,
    payload: error,
  };
};

export const clearErrorDeletingYardMap = () => {
  return {
    type: CLEAR_ERROR_DELETING_YARD_MAP,
  };
};

export const resetYardMapState = () => {
  return {
    type: RESET_YARD_MAP_STATE,
  };
};
